import React, { useState, useCallback, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { LatLngTuple } from 'leaflet';


const OSMTestPage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { sid } = useParams();
    const [error, setError] = useState<boolean>(false);
    const [incorrectLink, setIncorrectLink] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

        const defaultCenter: LatLngTuple = [50.450441, 30.523550]; // Явно указываем тип
        const [center, setCenter] = useState<LatLngTuple>(defaultCenter); // Явно указываем тип


    return (
        <div>
            <div>TEST</div>
<button
    color='red'
    onClick={() => {
        console.log("Кнопка нажата!"); // Выводим сообщение в консоль
        setCenter([53.902735, 27.555691]); // Обновляем состояние (перемещаем карту)
    }}
>
    Click me to change center
</button>
                <MapContainer key={`${center[0]},${center[1]}`} center={center} zoom={13} scrollWheelZoom={false}>
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://tile.dc.asstra.com/osm/{z}/{x}/{y}.png"
                    />
                    <Marker position={[51.505, -0.09]}>
                        <Popup>
                            A pretty CSS3 popup. <br /> Easily customizable.
                        </Popup>
                    </Marker>
  </MapContainer>
        </div>
    );
};

export default OSMTestPage;
